export default "__VITE_ASSET__DZH3nJIN__"